export function getDataPath(idAttr: string) {
  if (!idAttr.includes("/")) return "v/"
  return ""
}
